import CatalogueItem from './CatalogueItem';

export default CatalogueItem;
